/**
 * OAuth 2.1 Authorization Server endpoints (MCP-connector consent).
 *
 * The SPA route /oauth/authorize (pages/OAuthAuthorize.tsx) is the interactive
 * half of the AS: api-service validates an incoming authorize request and
 * 302-bounces the browser here; the consent decision goes back over the
 * Bearer-authed XHR below and the SPA then navigates to the returned
 * redirect_url (the MCP client's callback).
 */

import { api } from '../client';
import type { OAuthAuthorizeDecisionRequest } from '../types';
import {
  OAuthAuthorizeDecisionResponseSchema,
  OAuthClientInfoSchema,
} from '../schemas';
import { parseResponse } from '../validation';

export const oauthApi = {
  /** Display identity for the consent card ("<client_name> requests access…"). */
  getClient: (clientId: string) =>
    api
      .get(`/oauth/clients/${encodeURIComponent(clientId)}`)
      .then((res) => parseResponse(OAuthClientInfoSchema, res, 'GET /oauth/clients/{client_id}')),

  /** Approve (mints the code) or deny; both resolve to the redirect_url to follow. */
  decide: (data: OAuthAuthorizeDecisionRequest) =>
    api
      .post('/oauth/authorize', data)
      .then((res) => parseResponse(OAuthAuthorizeDecisionResponseSchema, res, 'POST /oauth/authorize')),
};
